import { Dialog } from "../../components";
import { ReactComponent as Error } from "../../assets/icons/exclamation.svg";
import { ReactComponent as Success } from "../../assets/icons/check.svg";
import { Suspense } from "react";
import { VoiceControlPinForm } from "./";
import { loadTestComponent } from "../../utils";
import styles from "./VoiceControlPinDialog.module.scss";
import { useFormatMessage } from "../../i18n";
import { useVoiceControlPinForm } from "../../hooks";

const icons = {
  success: <Success />,
  error: <Error />,
};

const errorMessages = {
  BAD_REQUEST: "error_pin",
  VOICE_INVALID_DEVICE: "error_voice_invalid_device",
  VOICE_INVALID_STATE: "error_voice_invalid_state",
  SERVER_ERROR: "something_went_wrong",
};

const SUCCESS_MESSAGE = "pin_assigned_correctly";

export function VoiceControlPinDialog({ showModal, setShowModal }) {
  const tr = useFormatMessage();
  const {
    pin,
    pristine,
    pinInputErrorMsg,
    assignPinInProgress,
    pinError,
    pinDialogStatus,
    handleChange,
    handleSubmit,
    initForm,
  } = useVoiceControlPinForm();

  const buttons = {
    form: [
      {
        title: tr("close"),
        handler: () => setShowModal(false),
        variant: "light",
      },
      {
        title: tr("assign_pin"),
        handler: () => handleSubmit(),
        variant: "primary",
        loading: assignPinInProgress,
      },
    ],
    status: [
      {
        title: tr("close"),
        handler: () => setShowModal(false),
        variant: "light",
      },
    ],
  };

  VoiceControlPinDialog.Status = ({ variant }) => {
    return (
      <div className={styles.status}>
        {icons[variant]}
        <p>
          {pinError
            ? tr(errorMessages[pinError?.type] || errorMessages.SERVER_ERROR)
            : tr(SUCCESS_MESSAGE)}
        </p>
      </div>
    );
  };

  const TestingWrapper = loadTestComponent(
    () => import("../../components/test/TestingWrapper")
  );

  const VoiceControlTestPinDialogButtons = loadTestComponent(
    () => import("../../components/test/VoiceControlTestPinDialogButtons")
  );

  return (
    <Dialog
      isOpen={showModal}
      content={
        <>
          {pinDialogStatus ? (
            <VoiceControlPinDialog.Status variant={pinDialogStatus} />
          ) : (
            <VoiceControlPinForm
              pin={pin}
              handleChange={handleChange}
              pristine={pristine}
              pinInputErrorMsg={pinInputErrorMsg}
              handleSubmit={handleSubmit}
            />
          )}
          <Suspense fallback={<></>}>
            <TestingWrapper>
              <VoiceControlTestPinDialogButtons
                errorMessages={Object.keys(errorMessages)}
              />
            </TestingWrapper>
          </Suspense>
        </>
      }
      onClose={() => {
        setShowModal(false);
        initForm();
      }}
      buttons={pinDialogStatus ? buttons.status : buttons.form}
    />
  );
}
